import React from 'react';
import {FormattedMessage, injectIntl} from "react-intl";
import classNames from 'classnames';

import {s3FeatureImagePath, THUMBNAIL_SIZES} from "../../../misc/utils";
import Analytics from "../../../analytics";
import {UserPopupTypes} from "../constants";
import {getFeatureIsLocked, toFixedFeatureCost} from '../../../misc/helpers';
import FeatureName from "../featureName";
import {isFeatureEnabled} from "../../../misc/displayLogic";
import {getPriceWithIncluded} from "../../../misc/priceFunctions";
import {isNavItemNotInVisualizer} from "../featuresFunctions";

const navigationItem = (props) => {

  if (!props.currentFeature) {
    return props.isMobile
      ? <li className="menu-list__item"><div className="menu-list__item-feature"/></li>
      : <div className="feature feature--empty" key={"feature" + props.row + props.column}/>
  }

  const { fabricatorData, isPhoneNumberValidated, currentFeatureCartItemsCount } = props;

  const currentFeature = props.currentFeature.part;

  let styles = {};
  if (currentFeature.dbFeature.thumbnailUrl) {
    const size = props.isMobile
      ? THUMBNAIL_SIZES.small
      : props.largeThumbnail ? null : THUMBNAIL_SIZES.medium
    styles.backgroundImage = `url('${s3FeatureImagePath(currentFeature.dbFeature, size)}')`;
  } else if (props.currentFeature && currentFeature.customThumbnail) {
    styles.backgroundImage = `url('${currentFeature.customThumbnail}')`;
  }

  const featureIsEnabledForQt = isFeatureEnabled(currentFeature, "quotingTool");

  const fabricatorSettings = fabricatorData.settings;
  const allPagesEnabled = !document.kvConfig.visualizerOnly;

  let showPrice = false;
  if (fabricatorSettings.showPricing && !fabricatorData.hideCheckoutBreakdownCost && !fabricatorData.hidePricesFromUser) {
    if (!featureIsEnabledForQt) {
      showPrice = false;
    } else if ((fabricatorSettings.leadCapture && !(document.kvConfig.isBackend && document.kvConfig.jobId && document.kvConfig.canSaveQuote)) && !currentFeature.dbFeature.unlocked) {
      if (props.isPhoneNumberValidated) {
        showPrice = true
      }
    } else {
      showPrice = true
    }
  }

  const featureIsLocked = getFeatureIsLocked(currentFeature);

  const getQuoteEnabled = fabricatorSettings.enableQuote && !featureIsLocked;
  const quoteOrUnlockButtonVisible = featureIsLocked || (getQuoteEnabled && !isPhoneNumberValidated);

  const isAddToCartButtonVisible = props.isActive && allPagesEnabled && fabricatorSettings.showPricing && featureIsEnabledForQt && (
      (fabricatorSettings.leadCapture && (currentFeature.dbFeature.unlocked || props.isPhoneNumberValidated))
      || !(fabricatorSettings.leadCapture && !(document.kvConfig.isBackend && document.kvConfig.jobId && document.kvConfig.canSaveQuote)))
    && props.existInQtCategory && !quoteOrUnlockButtonVisible;

  const price = toFixedFeatureCost(currentFeature, 1);

  return props.isMobile ? (
    <li className="menu-list__item">
      <div className={"menu-list__item-feature"
      + (props.isActive ? " active" : "")
      + (props.currentFeature.matchesMetaFailed ? " menu-list__item-feature--disabled" : "")
      + (props.stoneFeature ? " menu-list__item-feature--stone" : "")
      + (props.customClassName ? ` menu-list__item-feature--${props.customClassName}` : "")}
           style={styles} key={currentFeature.id()}
           onClick={(event) => Analytics.sendClickEvent('feature-clicked-' + currentFeature.partName)
             && props.onItemClick(props.currentFeature, featureIsLocked, event)}>
        {isNavItemNotInVisualizer(props.currentFeature) ? (
          <span className="feature-not-available"><FormattedMessage id="navItem.notInVisualizer"/></span>
        ) : null}
        {currentFeatureCartItemsCount > 0 ?
          <span className="materials-button--cart-length bold">{currentFeatureCartItemsCount}</span> : null
        }
        <div className={"menu-list__item-feature-text" + (props.isPulsating && !featureIsLocked ? " feature-text--pulsating" : "")}>
          {showPrice ? (
            <span className="menu-list__item-feature-text-price">
              {getPriceWithIncluded(price, currentFeature, fabricatorData, props.intl.messages)}
            </span>
          ) : null}
          {featureIsLocked
            ? <span className="menu-list__item-feature-text-price menu-list__item-feature-text-price--locked"/>
            : <span className="menu-list__item-feature-text-name"><FeatureName feature={currentFeature}/></span>}
        </div>
      </div>
      {props.isActive && !currentFeature.dbFeature.autoAddToCart ? (
        <div className="menu-list__item-buttons">
          {isAddToCartButtonVisible ? (
            <button className="menu-list__item-add-to-cart" onClick={() => {
              Analytics.sendClickEvent('show-add-to-cart-' + currentFeature.partName)
              && props.switchToFeatureInfo(props.currentFeature)
            }}>
              <span className="menu-list__item-add-to-cart-text"><FormattedMessage id="navItem.addToCart"/></span>
            </button>
          ) : null}
          {quoteOrUnlockButtonVisible ? (
            <button className={classNames("menu-list__item-buttons__unlock ui-button2 ui-button2--green", {"ui-button2--getquote": getQuoteEnabled})}
                    onClick={() => props.handleUserLoginClick(
                      getQuoteEnabled ? UserPopupTypes.GetQuote : UserPopupTypes.Unlock
                    )}
                    id='btnUnlockSelectionMainListItem'>
              <FormattedMessage id={getQuoteEnabled ? "navItem.quoteButtonMobile" : "navItem.unlockButton"}/>
            </button>
          ) : null}
          {allPagesEnabled && props.existInQtCategory && !isAddToCartButtonVisible && !quoteOrUnlockButtonVisible && featureIsEnabledForQt ? (
            <span className="feature-info" onClick={() => {
              Analytics.sendClickEvent('feature-clicked-show-feature-info') &&
              Analytics.sendClickEvent('feature-clicked-show-feature-info-' + currentFeature.partName) &&
              props.switchToFeatureInfo(props.currentFeature)
            }}/>
          ) : null}
        </div>
      ) : null}
    </li>
  ) : (
    <div className={"feature" + (props.isActive ? " active" : "")
    + (props.currentFeature.matchesMetaFailed ? " feature--disabled" : "")
    + (props.stoneFeature ? " feature--stone" : "")
    + (props.customClassName ? ` feature--${props.customClassName}` : "")}
         style={styles} key={currentFeature.id()}
         onClick={(event) => Analytics.sendClickEvent('feature-clicked')
           && Analytics.sendClickEvent('feature-clicked-' + currentFeature.partName)
           && props.onItemClick(props.currentFeature, featureIsLocked, event)}>

      {currentFeature.vanitySize ?
        <span className="feature-size">{currentFeature.vanitySize}"</span> : null
      }
      {currentFeatureCartItemsCount > 0 ?
        <span className="materials-button--cart-length bold">{currentFeatureCartItemsCount}</span> : null
      }
      {props.isActive && !currentFeature.dbFeature.autoAddToCart ? (
        <div className="feature-buttons">
          {isAddToCartButtonVisible ? (
            <button className="feature-add-to-cart"
                    onClick={() => Analytics.sendClickEvent('feature-clicked-add-to-cart') &&
                      Analytics.sendClickEvent('feature-clicked-add-to-cart-' + currentFeature.partName)
                      && props.switchToFeatureInfo(props.currentFeature)}>
              <FormattedMessage id="navItem.addToCart1"/> <span className="feature-add-to-cart__to-cart">
              {fabricatorData.isLowes ? null : <FormattedMessage id="navItem.addToCart2"/>}
            </span>
            </button>
          ) : null}
          {quoteOrUnlockButtonVisible ? (
            <button className={classNames("feature-buttons__unlock ui-button2 ui-button2--green", {"ui-button2--getquote": getQuoteEnabled})}
                    onClick={() => Analytics.sendClickEvent('get-quote-navigation-feature-item') && props.handleUserLoginClick(
                      getQuoteEnabled ? UserPopupTypes.GetQuote : UserPopupTypes.Unlock
                    )}
                    id='btnUnlockBodyItem'>
              <FormattedMessage id={getQuoteEnabled ? "navItem.quoteButton" : "navItem.unlockButton"}/>
            </button>
          ) : null}
          {allPagesEnabled && props.existInQtCategory && featureIsEnabledForQt ? (
            <span className="feature-info" onClick={() => {
              Analytics.sendClickEvent('feature-clicked-show-feature-info') &&
              Analytics.sendClickEvent('feature-clicked-show-feature-info-' + currentFeature.partName) &&
              props.switchToFeatureInfo(props.currentFeature)
            }}/>
          ) : null}
        </div>
      ) : null}
      {isNavItemNotInVisualizer(props.currentFeature) ? (
        <span className="feature-not-available"><FormattedMessage id="navItem.notInVisualizer"/></span>
      ) : null}
      <div className={"feature-text" + (featureIsLocked ? " feature-text--locked" : " feature-text--unlocked")
      + (props.isPulsating && !featureIsLocked ? " feature-text--pulsating" : "")}>
        {showPrice ? (
          <span className="feature-text__price">
            {getPriceWithIncluded(price, currentFeature, fabricatorData, props.intl.messages)}
          </span>
        ) : null}
        {!featureIsLocked ? <span className="feature-text__name"><FeatureName feature={currentFeature}/></span> : null}
      </div>
    </div>
  );
}

navigationItem.displayName = "navigationItem";
export default injectIntl(navigationItem)
